import {
  CATALOG_NICHE_BOOK_LIST_SET_DATA, CATALOG_NICHE_BOOK_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  nicheSlug: null,
  niche: null,
  books: null,
  paginateBy: 18,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  totalBookCount: null,
  subscriptionId: null,
  bookType: null,
};

export default function catalogBookList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_NICHE_BOOK_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_NICHE_BOOK_LIST_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
